const en = {
  meta: {
    home: { title: 'F&L Group — We create images, experiences and brands that last', desc: 'Portuguese creative group with two specialised areas: F&L Media (photography, video, marketing, websites) and F&L Souvenir (souvenir photography).' },
    media: { title: 'F&L Media — Photography, Video, Marketing and Websites', desc: 'Content that shapes your ideas. Photography, video, marketing and website production for companies, brands and projects.' },
    souvenir: { title: 'F&L Souvenir — Souvenir Photography for Leisure Venues', desc: 'We turn moments into memories. Souvenir photography solutions for leisure, tourism and entertainment venues.' },
    portfolio: { title: 'Portfolio — F&L Group', desc: 'A selection of work from the two F&L Group areas: F&L Media and F&L Souvenir.' },
    about: { title: 'About Us — F&L Group', desc: 'Two people. Four years of experience. One growing group. Meet Miguel Martins and Rafael Ribeiro.' },
    contact: { title: 'Contact — F&L Group', desc: "Let's create something together. Tell us about your project or partnership." },
    privacy: { title: 'Privacy Policy — F&L Group', desc: 'F&L Group Privacy Policy.' },
    cookies: { title: 'Cookie Policy — F&L Group', desc: 'F&L Group Cookie Policy.' },
    terms: { title: 'Terms and Conditions — F&L Group', desc: 'F&L Group Terms and Conditions.' },
  },
  nav: {
    home: 'Home', media: 'F&L Media', souvenir: 'F&L Souvenir',
    portfolio: 'Portfolio', about: 'About Us', contact: 'Contact',
    cta: 'Talk To Us', openMenu: 'Open menu', closeMenu: 'Close menu',
  },
  cursor: { view: 'VIEW', open: 'OPEN', play: 'PLAY', explore: 'EXPLORE', contact: 'CONTACT', viewProject: 'VIEW PROJECT' },
  home: {
    kicker: 'Creative Group · Portugal',
    titleA: 'We create images,',
    titleB: 'experiences and brands',
    titleC: 'that last.',
    sub: 'A creative group with two specialised areas.',
    scroll: 'Scroll to explore',
    media: { tag: 'Content that shapes your ideas.', desc: 'We produce photography, video, marketing and websites for companies, brands and projects.', cta: 'Explore F&L Media' },
    souvenir: { tag: 'We turn moments into memories.', desc: 'We create souvenir photography solutions for leisure, tourism and entertainment venues.', cta: 'Explore F&L Souvenir' },
    groupKicker: 'The Group',
    groupTitle: 'Two brands. One vision.',
    groupText: 'F&L Group brings together four years of experience in photography, video and communication — now organised into two specialised areas that complement each other.',
    statYears: 'Years of experience',
    statBrands: 'Specialised brands',
    statAreas: 'Creative areas',
    statVision: 'Shared vision',
    aboutCta: 'Meet F&L Group',
    b2b2cKicker: 'The Model',
    b2b2cTitle: 'One business, two audiences.',
    b2bTitle: 'B2B — Companies & Venues',
    b2bText: 'We work directly with companies, brands and projects through F&L Media, and with leisure, tourism and entertainment venues through F&L Souvenir — solutions tailored to each partner.',
    b2cTitle: 'B2C — Visitors & Public',
    b2cText: 'Through F&L Souvenir, we create personalised photographic keepsakes for the people visiting each venue — the end audience that takes the moment home with them.',
    contactKicker: 'Contact',
    contactTitle: "Shall we create something together?",
    contactMediaBrand: 'F&L Media',
    contactMediaTitle: 'Request a quote',
    contactMediaText: 'Photography, video, marketing and websites for businesses, individuals, events and personal projects.',
    contactSouvenirBrand: 'F&L Souvenir',
    contactSouvenirTitle: 'Propose a partnership',
    contactSouvenirText: 'Photographic experiences and personalised keepsakes for tourism and leisure venues.',
    marquee: ['Photography', 'Video', 'Marketing', 'Websites', 'Experiences', 'Souvenir', 'Content', 'Brands'],
  },
  media: {
    kicker: 'F&L Media',
    title: 'Content that shapes your ideas.',
    desc: 'We create visual content and digital solutions for companies, brands and projects looking to communicate better.',
    servicesKicker: 'Services',
    servicesTitle: 'What we do',
    services: [
      { title: 'Photography', desc: 'Professional photography for brands, companies, products, events, lifestyle and projects.' },
      { title: 'Video', desc: 'Video production for companies, brands, events, social media and audiovisual projects.' },
      { title: 'Marketing', desc: 'Content creation and communication solutions tailored to each brand and goal.' },
      { title: 'Websites', desc: 'Modern, responsive websites built around the identity of each project.' },
    ],
    workKicker: 'Portfolio',
    workTitle: 'F&L Media Work',
    workCta: 'View portfolio',
    filters: { all: 'All', photo: 'Photo', video: 'Video', marketing: 'Marketing', web: 'Web' },
    ctaTitle: 'Have a project in mind?',
    galleryTitle: 'Kartódromo Internacional de Braga',
    galleryText: 'On-track photography coverage.',
    ctaText: 'Tell us your idea and get a tailored proposal.',
    ctaButton: 'Request a Quote',
  },
  souvenir: {
    kicker: 'F&L Souvenir',
    title: 'We turn moments into memories.',
    desc: 'We create and operate souvenir photography solutions for leisure, tourism and entertainment venues.',
    stepsKicker: 'How It Works',
    stepsTitle: 'From experience to memory',
    steps: [
      { title: 'We capture', desc: 'We photograph visitors during the experience.' },
      { title: 'We personalise', desc: 'We create themed photos and covers related to the venue.' },
      { title: 'We produce', desc: 'We deliver printed and/or digital photographs.' },
      { title: 'We last', desc: 'The visitor takes home a personalised memory of the experience.' },
    ],
    venuesKicker: 'Venues & Experiences',
    venuesTitle: 'Where we can create memories',
    venueNote: 'Currently operating at a karting track — and ready to bring the experience to other venues.',
    venueActive: 'Now operating',
    venues: ['Karting', 'Surf', 'Theme Parks', 'Zoos', 'Aquariums', 'Water Parks', 'Adventure Parks', 'Tourism', 'Other Experiences'],
    coversKicker: 'Themed Covers',
    coversTitle: 'Every venue has a story. So does the photo.',
    coversText: "We design covers and graphic elements inspired by each venue's identity and experience, turning a photograph into a true keepsake.",
    coversFlow: ['Photograph', 'Personalised Cover', 'Souvenir'],
    coversExample: 'From the moment to the printed memory',
    b2bKicker: 'For Partner Venues',
    b2bTitle: 'More than photos. An integrated experience.',
    benefits: [
      { title: 'More value in every visit', desc: 'An integrated photography experience that enriches each visit and creates personalised memories.' },
      { title: 'More value for visitors', desc: 'A keepsake that extends the experience beyond the visit.' },
      { title: 'Personalised memory', desc: "Every photo is framed within the venue's identity." },
      { title: 'Content tied to the venue', desc: "Visual material that reinforces the partner's brand." },
      { title: 'Operation adapted to you', desc: "A setup adjusted to each partner's reality and pace." },
      { title: 'Professional image', desc: 'Professional-grade team, equipment and finishing.' },
    ],
    workKicker: 'Portfolio',
    workTitle: 'F&L Souvenir Work',
    filters: { all: 'All', leisure: 'Leisure Venues', tourism: 'Tourism', souvenir: 'Souvenir Photography', covers: 'Themed Covers' },
    ctaTitle: 'Do you run a leisure or tourism venue?',
    ctaText: "Let's talk about creating a new experience for your visitors.",
    ctaButton: 'Become a Partner',
  },
  portfolio: {
    kicker: 'Portfolio',
    title: 'Our Work',
    desc: 'A selection of projects from the two F&L Group areas.',
    empty: 'No projects in this category yet.',
    notFound: 'Project not found',
  },
  project: {
    back: 'Back to portfolio',
    next: 'Next project',
    about: 'About the project',
    objective: 'The objective',
    challenge: 'The challenge',
    whatWeDid: 'What we did',
    gallery: 'Gallery',
    results: 'Results',
    client: 'Client',
  },
  about: {
    kicker: 'About Us',
    titleA: 'Two people.',
    titleB: 'Four years of experience.',
    titleC: 'One growing group.',
    text: 'F&L Group was born from four years of experience in photography, video and communication. Today, that experience is organised into two specialised areas: F&L Media and F&L Souvenir.',
    foundersKicker: 'Founders',
    foundersTitle: 'The people behind F&L Group',
    founders: [
      { name: 'Miguel Martins', role: 'Co-Founder' },
      { name: 'Rafael Ribeiro', role: 'Co-Founder' },
    ],
    timelineKicker: 'Our Journey',
    timelineTitle: '2022 — Today',
    timelineNote: 'Reserved space for the company’s real milestones — no invented numbers, awards or achievements.',
    timelinePlaceholder: 'Milestone to be added',
    cta: 'Work with us',
  },
  contact: {
    kicker: 'Contact',
    title: "Let's create something together?",
    desc: 'Pick the right area and tell us what you have in mind.',
    generalEmailLabel: 'General email',
    phoneLabel: 'Phone',
    whatsappCta: 'Chat on WhatsApp',
    mediaTab: 'F&L Media',
    mediaTag: 'Photography · Video · Marketing · Websites',
    mediaCta: 'Request a Quote',
    souvenirTab: 'F&L Souvenir',
    souvenirTag: 'Leisure venues · Tourism · Souvenir photography · Partnerships',
    souvenirCta: 'Become a Partner',
    form: {
      name: 'Name', email: 'Email', phone: 'Phone (optional)', company: 'Company',
      companyOptional: 'Company (optional)',
      venue: 'Company / Venue', venueType: 'Venue type', location: 'Location',
      service: 'Service', budget: 'Investment expectation',
      message: 'Message',
      messagePlaceholder: 'Tell us what you have in mind...',
      consentPrefix: 'I have read and accept the',
      privacyLink: 'Privacy Policy',
      submit: 'Send Message',
      sending: 'Sending...',
      successTitle: 'Message sent!',
      successText: 'Thanks for reaching out. We will get back to you as soon as possible.',
      errorText: 'Something went wrong. Please try again or contact us directly.',
      select: 'Select...',
      services: ['Photography', 'Video', 'Marketing', 'Website', 'Other'],
      budgets: ['€50 – €500', '€500 – €1,000', '€1,000 – €3,000', '€3,000 – €5,000', '€5,000 – €10,000', '€10,000 +'],
      venueTypes: ['Karting', 'Surf', 'Theme Park', 'Zoo', 'Aquarium', 'Water Park', 'Adventure Park', 'Tourism', 'Other'],
    },
  },
  footer: {
    tagline: 'Media. Souvenir. Experience.',
    navigation: 'Navigation',
    legal: 'Legal',
    follow: 'Follow us',
    rights: '© F&L Group — All rights reserved.',
  },
  cookie: {
    title: 'Cookies',
    text: 'We use essential cookies to make this website work and, with your consent, analytics cookies to improve your experience.',
    accept: 'Accept',
    refuse: 'Refuse',
    configure: 'Configure',
    save: 'Save preferences',
    essential: 'Essential',
    essentialDesc: 'Required for the website to function. Always on.',
    analytics: 'Analytics',
    analyticsDesc: 'Help us understand how the website is used.',
    alwaysOn: 'Always on',
  },
  legal: {
    privacy: {
      title: 'Privacy Policy',
      updated: 'Last updated: 6 October 2026',
      sections: [
        { h: '1. Data controller', p: 'Legal company name: [to be added] · Tax number (NIF): [to be added] · Address: [to be added] · Email: geral@flgroup.pt · Data protection contact: [to be added].' },
        { h: '2. Data we collect', p: 'Contact forms: we collect the data you voluntarily provide — name, email, phone (optional), company/venue (optional), requested service, investment expectation (F&L Media form), venue type and location (F&L Souvenir form) and the content of your message. This data is stored in a secure database, emailed to the relevant brand team and triggers an automatic confirmation email to you. Íris virtual assistant: messages written in the chat are transmitted to an artificial intelligence provider (OpenAI) solely to generate the reply and are not stored — each conversation is processed in the moment and is not recorded. We recommend not sharing sensitive data in the chat. For abuse prevention, your IP address is used temporarily to limit the number of messages, with no permanent record.' },
        { h: '3. Purposes of processing', p: 'The data collected is used exclusively to respond to contact requests, prepare commercial proposals, manage potential partnerships and provide the virtual assistant service. We do not use your data for marketing without prior consent.' },
        { h: '4. Legal basis', p: 'Processing is based on the data subject’s consent (Art. 6(1)(a) GDPR), given by accepting this policy when submitting a form.' },
        { h: '5. Data retention', p: 'Data from contact and quote requests that do not proceed is automatically deleted 6 months after the last contact. Client data and data required to fulfil contractual, tax or legal obligations (for example, invoicing data, kept for the periods set out in tax law) is retained for the legally required periods. Conversations with the Íris virtual assistant are not retained.' },
        { h: '6. Data sharing', p: 'Data is not sold or shared for marketing purposes. It is transmitted only to the providers strictly necessary to operate the service: the email provider that delivers the form notifications and confirmations, and the artificial intelligence provider (OpenAI) that processes Íris chat messages in the moment, without storing them. Any other sharing occurs only where required by law.' },
        { h: '7. Your rights', p: 'Under the GDPR you have the right to access, rectify, erase, restrict, port and object to the processing of your data. To exercise these rights, contact us at geral@flgroup.pt. You may also lodge a complaint with the CNPD — the Portuguese Data Protection Authority.' },
        { h: '8. Cookies', p: 'For detailed information on the use of cookies on this website, please see our Cookie Policy.' },
        { h: '9. Changes to this policy', p: 'This policy may be updated from time to time. The version in force is the one published on this page, with its respective update date.' },
      ],
    },
    cookies: {
      title: 'Cookie Policy',
      updated: 'Last updated: 1 October 2026',
      sections: [
        { h: '1. What are cookies', p: 'Cookies are small text files stored on your device when you visit a website, enabling it to function and, with consent, to collect statistical information.' },
        { h: '2. Cookies we use', p: 'Essential cookies: required for the technical operation of the website (for example, language preference and cookie consent). These do not require consent. Analytics cookies: [to be added if analytics tools are used — currently not active].' },
        { h: '3. Managing consent', p: 'When you access the website, you can accept, refuse or configure non-essential cookies through the consent banner. You can change your decision at any time.' },
        { h: '4. How to disable cookies', p: 'You can also manage or delete cookies through your browser settings. Disabling essential cookies may affect how the website works.' },
        { h: '5. Contact', p: 'For questions about this policy, contact us at geral@flgroup.pt.' },
      ],
    },
    terms: {
      title: 'Terms and Conditions',
      updated: 'Last updated: 1 October 2026',
      sections: [
        { h: '1. Identification', p: 'This website is owned by [legal company name to be added], tax number [to be added], headquartered at [address to be added], hereinafter referred to as F&L Group.' },
        { h: '2. Purpose', p: 'These terms govern the use of this website, which is of an informational and commercial nature, presenting the services of the F&L Media and F&L Souvenir brands.' },
        { h: '3. Intellectual property', p: 'All content on this website — including text, photographs, videos, logos and graphics — is the property of F&L Group or used with authorisation, and may not be reproduced without prior consent.' },
        { h: '4. Liability', p: 'F&L Group strives to keep the information on this website accurate and up to date, but cannot guarantee the absence of errors or uninterrupted availability.' },
        { h: '5. External links', p: 'This website may contain links to third-party websites, for which F&L Group accepts no responsibility.' },
        { h: '6. Governing law', p: 'These terms are governed by Portuguese law. The competent jurisdiction for dispute resolution is [to be added].' },
      ],
    },
  },
  notFound: { title: 'Page not found', text: 'The page you are looking for does not exist.', cta: 'Back to home' },
  chat: {
    title: 'Íris',
    subtitle: 'AI Assistant · F&L Group',
    welcome: "Hi! I'm Íris, the F&L Group virtual assistant. I can help you discover our services and find the information you're looking for. How can I help?",
    disclaimer: "I'm an AI assistant. Please don't share sensitive data — conversations are not stored.",
    whatsapp: 'Chat on WhatsApp',
    placeholder: 'Type your message...',
    send: 'Send',
    open: 'Chat with Íris',
    minimize: 'Minimize',
    close: 'Close chat',
    suggestions: ['What does F&L Media do?', 'How does F&L Souvenir work?', 'I want to request a quote', 'How can I contact you?'],
    offline: "I can't respond right now. Please contact us directly at geral@flgroup.pt.",
    rateLimited: 'You have reached the hourly message limit. To keep talking, contact us at geral@flgroup.pt.',
  },
};

export default en;
